<template>
  <div class="submenu2 text-left">
    <v-slide-y-reverse-transition>
      <v-card class="rounded-un shaddow-un pb-15" width="100%" dark color="#502D7C" v-if="menu">
        <v-container>
          <div class="pr-2 pt-2 text-right">
            <v-icon @click="openConf()">mdi-close</v-icon>
          </div>

          <div class="mb-2">
            <v-btn class="font-dm" @click="goTo('/perfil')" depressed text>
              <img :src="require(`@/assets/Group-white.png`)" width="20px" class="mr-5" />
              Meu Perfil
            </v-btn>
          </div>

          <div v-for="(item, i) in conf2.menu" :key="i" class="mb-2">
            <v-btn class="font-dm" @click="goTo(item.route)" depressed text>
              <img :src="require(`@/assets/${item.icon}`)" width="20px" class="mr-5" />
              {{ item.text }}
            </v-btn>
          </div>

          <div class="mb-2">
            <v-btn class="font-dm" @click="openTutorial()" depressed text>
              <img :src="require(`@/assets/alert-circle@1,5x.svg`)" width="20px" class="mr-5" />
              Tutorial Interativo
            </v-btn>
          </div>

          <div class="mb-2">
            <v-btn class="font-dm" @click="goTo('/page/regras')" depressed text>
              <img src="@/assets/book-white.png" width="20px" class="mr-5" />
              Regras e Regulamento
            </v-btn>
          </div>

          <v-btn class="font-dm" @click="preventLogoff()" depressed text>
            <img src="@/assets/log-out-white.png" width="20px" class="mr-5" />
            Sair
          </v-btn>
        </v-container>
      </v-card>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['menu', 'option']),
  },
  data: () => ({
    conf2: {
      text: 'Configurações',
      icon: 'mdi-cog-outline',
      menu: [
        {
          text: 'Sobre Nós',
          icon: 'book-open-white.png',
          route: '/page/sobre',
        },
        { text: 'Salvos', icon: 'bookmark-white.png', route: '/salvos' },
      ],
    },
    prevent: false,
  }),
  methods: {
    logoff() {
      this.$store.dispatch('setMenuInfo', false)
      localStorage.removeItem('user')
      window.location = '//www.unisinos.br/conecta'
    },
    openConf() {
      this.$store.dispatch('setMenuInfo', false)
    },
    goTo(item) {
      this.$store.dispatch('setMenuInfo', false)
      this.$router.push(item)
    },
    openTutorial() {
      this.$store.dispatch('setErrorInfo', {
        open: true,
        text: 'Vamos reativar as dicas que vão lhe apresentar algumas funcionalidades da nossa plataforma.',
        button: 'Beleza, reativar!',
      })
      this.$store.dispatch('setMenuInfo', false)
      this.$store.dispatch('setResetInfo', true)
    },
    preventLogoff() {
      this.prevent = true
      this.$store.dispatch('setErrorInfo', {
        open: true,
        text: 'Tem certeza que deseja sair?',
        button: [{ text: 'Sair' }, { text: 'Não', outlined: true }],
      })
    },
  },
  watch: {
    option() {
      if (this.prevent) {
        if (this.option === 0) {
          this.logoff()
          this.prevent = false
        }
        if (this.option === 1) {
          this.prevent = false
        }
      }
    },
  },
}
</script>

<style>
.submenu2 {
  position: fixed;
  left: 0;
  bottom: 20px;
  width: 100% !important;
  z-index: 30;
}

.rounded-max {
  border-radius: 29px 29px 0 0 !important;
}
</style>
